import getShortTimeZone from './getShortTimeZone'
export default getShortTimeZone
